import * as React from "react"
import { Box } from "@mui/material";

import {ImageSkuBlock, SkuInfoBlock} from "@components"
import { useBuildExternalURL } from "@hooks"


export default function productSkuColumn() {
	return [{
		name: 'category', label: 'Category',
		options: { display: 'excluded' }
	}, {
		name: 'brand', label: 'Brand',
		options: { display: 'excluded' }
	}, {
		name: 'skuName', label: 'SKU',
		options: {
			display: 'excluded',
			filterType: 'textField'
		}
	}, {
		name: 'ean', label: 'EAN',
		options: {
			display: 'excluded',
			filter: false
		}
	}, {
		name: 'skuName',
		label: 'Product SKU',
		options: {
			filter: false,
			customBodyRowRender: (value, row) => <RenderProductSkuColumn value={value} row={row} />
		}
	}]
}

function RenderProductSkuColumn({ row, value }) {
	const { productURL } = useBuildExternalURL({ siteData: { siteID: row.siteID, productID: row.productID } })
	return <Box sx={{ display: 'flex'}}>

		<ImageSkuBlock
			skuID={row.skuID}
			date={row.date}
			skuName={row.skuName}
			siteID={row.siteID}
			productID={row.productID}
			contentProps={{ sx: {mr: 2, ml: 0} }}
		/>

		<SkuInfoBlock
			sku={value}
			category={row.category}
			brand={row.brand}
			ean={row.ean}
			reference={row.reference}
			productURL={productURL}
		/>
		
	</Box>
}